<template>
  <uni-popup
    class="tw-popup"
    :ref="refName"
    type="bottom"
    safeArea
    :backgroundColor="background"
    :mask-click="canMaskClose"
    @change="onChange"
  >
    <view @touchmove.stop.prevent="() => {}">
      <view class="popup-title" :style="{ background: background }" v-if="showHeader">
        <text class="popup-title-text">{{ title }}</text>
        <text class="close-btn f-s-32 c-cbcbcb tripwise_fill icon-close_fill" @click="onCancel"></text>
      </view>
      <view class="popup-content" :style="{ background: background }">
        <slot></slot>
      </view>
      <view class="popup-btn" v-if="showFooter">
        <slot name="footer">
          <button type="default" class="f-s-32 c-595959" @click="onCancel">{{ cancelText }}</button>
          <button type="primary" class="f-s-32 c-595959 btn-primary" @click="onOk">{{ okText }}</button>
        </slot>
      </view>
    </view>
  </uni-popup>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    refName: {
      type: String,
      default: 'twPopup',
    },
    okText: {
      type: String,
      default: '确认',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
    open: {
      type: Boolean,
      default: false,
    },
    // 展示popup的背景色
    background: {
      type: String,
      default: '#fff',
    },
    // 是否展示底部按钮
    showFooter: {
      type: Boolean,
      default: true,
    },
    // 点击蒙层是否关闭弹框
    canMaskClose: {
      type: Boolean,
      default: true,
    },
    // 是否展示头部
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  watch: {
    open: {
      handler: function (val) {
        if (val) {
          this.$refs[this.refName] && this.$refs[this.refName].open();
        } else {
          this.$refs[this.refName] && this.$refs[this.refName].close();
        }
      },
      immediate: true,
    },
  },
  methods: {
    onCancel() {
      this.closePopup();
    },
    onOk() {
      this.$emit('ok');
    },
    onChange(e) {
      this.$emit('change', e.show);
    },
    closePopup() {
      this.$refs[this.refName] && this.$refs[this.refName].close();
    },
    openPopup() {
      this.$refs[this.refName] && this.$refs[this.refName].open();
    },
  },
};
</script>
<style lang="less" scoped scoped>
/deep/ .uni-popup__wrapper.uni-custom.bottom .uni-popup__wrapper-box {
  padding: 0;
  background: none;
  max-height: initial;
}
/deep/ uni-button[type='default'] {
  background-color: transparent;
}

.tw-popup {
  z-index: 1000;
}
.popup-title {
  position: relative;
  height: 88rpx;
  line-height: 88rpx;
  border-radius: 20rpx 20rpx 0 0;
  background-color: #fff;
  text-align: center;
  .popup-title-text {
    font-size: 32rpx;
    color: #141414;
    font-weight: 600;
  }
  .close-btn {
    position: absolute;
    right: 30rpx;
    top: 0;
  }
}
.popup-content {
  padding: 0 30rpx;
  background-color: #fff;
}
.popup-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 20rpx;
  background-color: #fff;
  padding: 20rpx 30rpx;
  & > * {
    flex: 1;
  }
  button {
    height: 80rpx;
    line-height: 80rpx;
    border-radius: 8rpx;
  }
}
</style>
